export const iconFontAwesomeFruitsVegetablesAppleWhole = (
	<i className="fa-solid fa-apple-whole"></i>
);
